import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ViewDidEnter, ViewDidLeave, ViewWillEnter } from '@ionic/angular';
import {
  PanAppState,
  TokenAuthMode,
  UsfTokenService,
} from '@panamax/app-state';
import { environment } from '../../../../environments/environment';
import { Crumb } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { PageTitle } from '../../../shared/constants/page-titles.enum';

@Component({
  selector: 'app-aog',
  templateUrl: './aog.page.html',
  styleUrls: ['./aog.page.scss'],
})
export class AogPage implements ViewWillEnter, ViewDidLeave {
  breadcrumbs: Crumb[];
  iframeUrl: SafeResourceUrl;
  isLoaded: boolean;

  constructor(
    protected sanitizer: DomSanitizer,
    private tokenService: UsfTokenService,
    private panAppState: PanAppState,
  ) {}

  ionViewWillEnter() {
    window.addEventListener('message', this.requestTokenMessageHandler);
    this.panAppState.setPageTitle(PageTitle.aog);
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.aogUrl}embed`,
    );
    this.breadcrumbs = [
      {
        label: 'i18n.breadcrumbs.home',
        url: '/desktop/home',
        active: false,
      },
      {
        label: 'i18n.breadcrumbs.myLists',
        url: '/lists',
        active: false,
      },
      {
        label: 'i18n.breadcrumbs.aog',
        url: '',
        active: true,
      },
    ];
    this.isLoaded = false;
  }

  ionViewDidLeave(): void {
    window.removeEventListener('message', this.requestTokenMessageHandler);
  }

  requestTokenMessageHandler = async (event: MessageEvent<any>) => {
    if (event.data === 'requestToken') {
      const iframe = document.querySelector('.iframe') as HTMLIFrameElement;
      if (iframe?.contentWindow) {
        const token = await this.tokenService.authorize(TokenAuthMode.Local);
        if (token) {
          iframe.contentWindow.postMessage({ token: token }, '*');
          this.isLoaded = true;
        }
      }
    }
  };
}
